export default {
      valorContribuicaoHome: state => {
        return state.valorContribuicaoHome
      },
      user: state => {
        return state.user
      },
      cartaoVigente: state => {
        return state.cartaoVigente
      },
      precisaRealizarRecadastro: state => {
        if(_.isNull(state.user)){
          return false
        }
        if(_.toNumber(state.user.pk_id_filiado) == 0){
          return false
        }
        if(state.user.filiado_foi_aprovado || state.user.filiado_realizou_recadastro){
          return false
        }
        return true
      },
      precisaCompletarFichaDeFiliacao: state => {
        if(_.isNull(state.user)){
          return false
        }
        if(_.toNumber(state.user.pk_id_filiado) == 0){
          return false
        }
        return !state.user.filiado_foi_aprovado || !state.user.filiado_realizou_recadastro
      },
      contribuicaoInicialNaoRealizada: state => {
        if(_.isNull(state.user)){
          return false
        }
        if(_.toNumber(state.user.pk_id_filiado) == 0){
          return true
        }
        return !state.user.foi_solicitada_a_emissao_de_cartao || !state.user.pagamento_de_emissao_da_cnm_foi_realizado
      },
      formularioPrimeiraContribuicao: state => {
        if(_.isNull(state.user)){
          return false
        }
        return !state.user.usuario_possui_algum_cartao_vinculado || (_.toNumber(state.user.pk_id_filiado) > 0 && state.user.usuario_possui_algum_cartao_vinculado && state.user.cartao_vigente_do_usuario.tipo_cartao == 2)
      },
      infoAcessoCartao: state => {
        let user = state.user
        if(_.isNull(user)){
          user = {
            button: {
              label: 'Solicite a sua',
              route: 'autenticacao',
              params: {
                  tipo: 'emissao'
              },
            }
          }
        }
        else{
          user.button = {
            label: user.pk_id_filiado > 0 ? (user.usuario_possui_algum_cartao_vinculado  ? 'Minha carteira' : 'Solicite a sua') : 'Solicite a sua',
            route: user.pk_id_filiado > 0 ? (user.usuario_possui_algum_cartao_vinculado  ? 'minha.carteira' : 'confirmacao.de.dados') : 'confirmacao.de.dados',
             params: user.pk_id_filiado > 0 ?  {tipo: 'emissao'} : {},
          }
        }
        return user
      },
      primeiroNome: state => {
        let primeiroNome = null
        if(state.user) {
          let nome = state.user.dados_perfil.nome_social ? state.user.dados_perfil.nome_social : state.user.dados_perfil.nome_completo
          nome = _.split(nome, ' ')
          primeiroNome = nome[0]
        }
        return primeiroNome
      },
      getMenuLogado: state => {
        let idFiliado = 0
        var deveExibirMinhaCarteira = false;

        if(state.user){
          idFiliado = state.user.pk_id_filiado
          deveExibirMinhaCarteira = state.user.cartao_vigente_do_usuario.pk_id_cartao_pcdob > 0
        }

        var menu = idFiliado > 0 ? _.concat(state.menu.comum, state.menu.logado_filiado, state.menu.logado) :  _.concat(state.menu.comum, state.menu.logado)

        if(deveExibirMinhaCarteira && idFiliado > 0)
        {
            menu = _.concat(state.menu.comum, state.menu.minha_carteira,state.menu.logado_filiado, state.menu.logado)
        }

        return menu;
      },
      getMenuNaoLogado: state => {
        return  _.concat(state.menu.comum, state.menu.nao_logado)
      },
      getCarrinho: state => {
        return state.carrinho
      },
      getConfirmacaoPagamento: state => {
        return state.confirmacaoPagamento
      },
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js